import { useEffect, useRef, useState } from "react";
import css from "./AddressSelector.module.css";
import { BsFillCaretDownFill } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { selectSelectedServiceId } from "../../redux/auth/selectors.js";
import { setSelectedServiceId } from "../../redux/auth/slice.js";
import { selectAllServices } from "../../redux/service/selectors.js";
import { changeSelectedService } from "../../redux/auth/operations.js";
import { checkTariffs } from "../../redux/service/operations.js";

export default function AddressSelector() {
  const dispatch = useDispatch();

  const services = useSelector(selectAllServices);
  const selectedServiceIdInState = useSelector(selectSelectedServiceId);

  const [servicesToDisplay, setServicesToDisplay] = useState([]);
  useEffect(() => {
    if (services.length > 0) {
      setServicesToDisplay(services);
    }
  }, [services]);

  // console.log("services in AddressSelector:", services);
  // console.log("selectedServiceIdInState in AddressSelector:", selectedServiceIdInState);

  useEffect(() => {
    if (services.length > 0 && !selectedServiceIdInState) {
      dispatch(setSelectedServiceId(services[0].id));
    }
  }, [services, selectedServiceIdInState, dispatch]);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const selectRef = useRef(null);

  const toggleDropdown = () => {
    setIsDropdownOpen(prev => !prev);
  };
  const handleBlur = event => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setIsDropdownOpen(false);
    }
  };

  const handleSelectService = event => {
    const selectedServiceId = Number(event.target.value);

    dispatch(setSelectedServiceId(selectedServiceId));
    dispatch(changeSelectedService(selectedServiceId))
      .unwrap()
      .then(() => {
        dispatch(checkTariffs());
      });
  };

  return (
    <div className={css.selectBox} ref={selectRef} onBlur={handleBlur}>
      <select
        id="address"
        name="address"
        className={css.select}
        onClick={toggleDropdown}
        onChange={handleSelectService}
        value={selectedServiceIdInState ?? ""}
      >
        {servicesToDisplay.map(service => (
          <option key={service.id} value={service.id}>
            {service.name}
          </option>
        ))}
      </select>
      <BsFillCaretDownFill
        className={`${css.btnArrowSelect} ${isDropdownOpen ? css.rotated : ""}`}
      />
    </div>
  );
}
